import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ButtonDefault extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      showLoading: false
    };
  }

  render() {
    const {
      type,
      classNames,
      disabled,
      showLoading,
      buttonTitle,
      buttonLoadingTitle
    } = this.props;

    return (
      <button
        type={type}
        className={classNames}
        disabled={disabled === true ? disabled : this.state.disabled}
      >
        {showLoading === true ? buttonLoadingTitle : buttonTitle}
      </button>
    );
  }
}

ButtonDefault.propTypes = {
  type: PropTypes.oneOf(['button', 'submit', 'reset']).isRequired,
  buttonTitle: PropTypes.string,
  buttonLoadingTitle: PropTypes.string,
  classNames: PropTypes.string,
  disabled: PropTypes.bool,
  showLoading: PropTypes.bool
};

ButtonDefault.defaultProps = {
  type: 'button',
  buttonTitle: 'Отправить',
  buttonLoadingTitle: 'Загрузка...',
  classNames: 'btn btn-default btn-block btn-primary btn-lg',
  disabled: false,
  showLoading: false
};

export default ButtonDefault;



// WEBPACK FOOTER //
// ./src/components/Common/Buttons/ButtonDefault/ButtonDefault.js